// @flow
import dj from 'dayjs'
import utc from 'dayjs/plugin/utc'
// TODO: uncomment when bug in Chrome will be fixed https://bugs.chromium.org/p/chromium/issues/detail?id=1169034&q=toLocaleString&can=2
// import timezone from 'dayjs/plugin/timezone'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import isBetween from 'dayjs/plugin/isBetween'
import dayjs_ru from 'dayjs/locale/ru'
import dayjs_en from 'dayjs/locale/en'
// TODO: remove when bug in Chrome will be fixed https://bugs.chromium.org/p/chromium/issues/detail?id=1169034&q=toLocaleString&can=2
import timezone from './fixed-timezone'
import type { DateProvider } from './types'

const LOCALES = {
  ru: dayjs_ru,
  en: dayjs_en,
}

// Create instance of dayjs with settings https://github.com/iamkun/dayjs/issues/1227
export class DayjsAdapter implements DateProvider<typeof dj> {
  static LOCALES = LOCALES

  timezone: string

  dayjs: typeof dj

  constructor() {
    this.dayjs = dj
    this.extend()
  }

  extend() {
    this.dayjs.extend(utc)
    this.dayjs.extend(timezone)
    this.dayjs.extend(customParseFormat)
    this.dayjs.extend(LocalizedFormat)
    this.dayjs.extend(isBetween)
    this.dayjs.extend(relativeTime)
  }

  initLocale(locale?: string) {
    const browserLocale = navigator.language.split('-')[0]

    if (locale === undefined || locale === null) {
      this.dayjs.locale(browserLocale)

      return
    }
    if (!DayjsAdapter.LOCALES[locale]) {
      this.dayjs.locale('ru', DayjsAdapter.LOCALES.ru)

      return
    }
    this.dayjs.locale(locale, DayjsAdapter.LOCALES[locale])
  }

  setDefaultLocale = () => {}

  setTimezone = (tz: string = 'Europe/Moscow') => {
    this.timezone = tz
    this.dayjs.tz.setDefault(tz)
  }

  getInstance = () => {
    return this.dayjs
  }
}
